import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';
/* import {
  Box, TextField, Container, Grid, Card, CardContent,
  Divider, Button, CircularProgress, Snackbar, FormControl,
  InputLabel, Select, MenuItem, Autocomplete,
  Typography,
  FormControlLabel
} from "@mui/material"; */
 import {
  Box,
  TextField,
  Container,
  Grid,
  Card,
  CardContent,
  Divider,
  Button,
  CircularProgress,
  Snackbar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Typography,
  FormControlLabel,
  Switch
} from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import { authenticationService } from "src/services";
import { put, get } from 'src/services/httpClient.service';
import { useSnackbar } from 'src/components/snackbar/useSnackbar';
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

// Package duration options (in months) shown in the dropdown
const PACKAGE_DURATION_OPTIONS = [1, 2, 3, 6, 12];

const EditUser = (props) => {
  const { showSnackbar } = useSnackbar();
  const {vendorId, franchiseId} = authenticationService.getVendorFranchiseIds();
  const { selectedLCOId, selectedLCOName, selectedLCOFranchiseId } = authenticationService.getSelectedLCO();
  const APIURL = process.env.REACT_APP_BASE_API_URL;

  // Get selected franchise from localStorage
  const selectedFranchise = JSON.parse(localStorage.getItem('selectedFranchise') || '{}');
  const franchiseCity = selectedFranchise?.city || selectedFranchise?.area || '';
  const companyEmail = localStorage.getItem('companyEmail');
  const [idProofFile, setIdProofFile] = useState(null);
  const [addressProofFile, setAddressProofFile] = useState(null);
  const [fileError, setFileError] = useState('');
  const [addressProofError, setAddressProofError] = useState('');

  const defaultFormValues = {
    userId: '',
    firstName: '',
    lastName: '',
    email: '',
    userName: '',
    userPassword: '',
    phone: '',
    landlineNumber: '',
    aadharNumber: '',
    address: '',
    address2: '',
    billingAddress1: '',
    billingAddress2: '',
    status: '',
    registeredDate: '',
    vendorId: vendorId,
    franchiseId: selectedLCOFranchiseId,
    fingerprintStatus: '',
    areaId: '',
    billingAreaId: '',

    //acn extra fields
    // business: '',
    // customerNumber: '',
    // dateOfBirth: '',
    // gender: '',
    // agent: '',
    // roads: '',
    // buildings: '',
    // wing: '',
    // floor: '',
    // flatNo: '',
    // memberType: '',
    // group: '',
    // postcode: '',
    // remarks: '',
    // gstNo: '',
    // panNo: '',
    // latitude: '',
    // longitude: '',
    isRental: false,
    autoRenewal: false,

    prepaidCustomer: false,
    billingTaxType: '',
    billDate: '',
    dueDate: '',
    servicePerson: '',
    collectionPerson: '',
    registeredDate: '',
    connectionDate: '',
    fixBillAmount: '',
    billingType: '',
    openingAmount: '',
    openingType: '',
    isFree: false,
    isStb: false,
    isApk: false,
    collectionDate: '',
    oneTimeCharges: '',
    securityDeposit: '',
    creditLimit: '',

    // NEW: package duration in months (1, 2, 3, 6, 12)
    packageDuration: '',
  };

  const [formValues, setFormValues] = useState(defaultFormValues);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  
  const [areaList, setAreaList] = useState([]);
  const [filteredAreaList, setFilteredAreaList] = useState([]);
  const [selectedAreaId, setSelectedAreaId] = useState('');
  const [selectedBillingAreaId, setSelectedBillingAreaId] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const accountType = localStorage.getItem('accountType');

  const [formErrors, setFormErrors] = useState({
    userPassword: '',
  });


  const [billingTaxTypes, setBillingTaxTypes] = useState([]);

const billingtaxtype = async () => {
  try {
    const res = await get(
      `${APIURL}/api/billing-tax-type/vendor/${vendorId}/getAll`
    );

    if (res?.success && res?.data) {
      setBillingTaxTypes(res.data);
    }
  } catch (error) {
    console.error("Error fetching billing tax types", error);
  }
};

useEffect(() => {
  billingtaxtype();
}, []);


const handleFileUpload = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const allowedTypes = [
    'application/pdf',
    'image/jpeg',
    'image/png'
  ];

  if (!allowedTypes.includes(file.type)) {
    setFileError('Only PDF, JPG and PNG files are allowed.');
    setIdProofFile(null);
  } else {
    setFileError('');
    setIdProofFile(file);
  }
};

const handleAddressProofUpload = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const allowedTypes = [
    'application/pdf',
    'image/jpeg',
    'image/png'
  ];

  if (!allowedTypes.includes(file.type)) {
    setAddressProofError('Only PDF, JPG and PNG files are allowed.');
    setAddressProofFile(null);
  } else {
    setAddressProofError('');
    setAddressProofFile(file);
  }
};

  /* =========================
      API TO Fetch AreaList
  ========================= */
  const fetchAreas = async () => {
    try {
      const response = await get(
        `${APIURL}/api/miscellaneous/area/vendor/${vendorId}/findAll`
      );
      
      if (response && response.data) {
        const allAreas = response.data;
        
        
       /*  if (franchiseCity) {
          const filteredAreas = allAreas.filter(area => 
            area.cityName?.toLowerCase().includes(franchiseCity.toLowerCase()) ||
            area.name?.toLowerCase().includes(franchiseCity.toLowerCase())
          );
          setAreaList(allAreas);
          setFilteredAreaList(filteredAreas);
        } else {
          
          setAreaList(allAreas);
          setFilteredAreaList(allAreas);
        } */
      if (response && response.data) {
  const allAreas = response.data;

  // Show all locations (no filtering)
  setAreaList(allAreas);
  setFilteredAreaList(allAreas);
}
        }
    } catch (error) {
      console.error("Error fetching areas", error);
      showSnackbar('Failed to fetch area list', 'error');
    }
  };

  useEffect(() => {
    fetchAreas();
  }, []);

  const handleChange = (e) => {
    const field =
e.target.name ||
e.target.id ||
e.target.getAttribute("data-field");

const value = e.target.value;

setFormValues((prev) => ({
...prev,
[field]: value,
}));

    let errors = { ...formErrors };

    if (field === 'userPassword') {
  if (value.trim() === '') {
    errors.userPassword = '';
  } else {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&^#()_+\-=[\]{};':"\\|,.<>/?]).{6,12}$/;

    errors.userPassword = passwordRegex.test(value)
      ? ''
      : 'Password must be 6-12 characters and contain uppercase, lowercase, number, and special character';
  }
}

    setFormErrors(errors);
  };

  const handleClose = () => {
    props.handleClose();
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const onUpdate = async () => {
    // Optional: Add validation for Aadhaar if needed
    if (formValues.aadharNumber && !/^\d{12}$/.test(formValues.aadharNumber)) {
      showSnackbar('Aadhaar number must be exactly 12 digits', 'error');
      return;
    }

    // Optional: Add validation for Landline if needed
    if (formValues.landlineNumber && formValues.landlineNumber.trim() !== '') {
      const landlineRegex = /^(\d{10,12}|(\d{2,5}[-]?\d{6,8})|\(\d{2,5}\)\d{6,8})$/;
      if (!landlineRegex.test(formValues.landlineNumber)) {
        showSnackbar('Enter a valid landline number (e.g., 0123456789 or 012-3456789)', 'error');
        return;
      }
    }

   const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&^#()_+\-=[\]{};':"\\|,.<>/?]).{6,12}$/;

if (
  formValues.userPassword &&
  !passwordRegex.test(formValues.userPassword)
) {
  showSnackbar(
    'Password must be 6-12 characters and contain uppercase, lowercase, number, and special character',
    'error'
  );
  return;
}
    setLoading(true);
    try {
      const response = await updateUser({
        ...formValues,
        venderId: vendorId,
        franchiseId: selectedLCOFranchiseId
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      showSnackbar('Failed to update Subscriber.', 'error');
    }
  };

  async function updateUser(data) {
    try {
      data['vendorId'] = vendorId;
      data['franchiseId'] = selectedLCOFranchiseId;
      if(accountType.trim() !== "OWNER") {
        data['assignedTo'] = selectedLCOId
      }
      const response = await put(`${APIURL}${process.env.REACT_APP_USER}`, data);
      console.log('response', response);
      if (response?.status === "OK") {
        showSnackbar(response?.responseMessage, 'success');
        props.handleClose();
      } else {
        showSnackbar('Subscriber failed to update', 'error');
      }
      return response.data;
    } catch (error) {
      console.error('Error updating subscriber:', error);
      showSnackbar(error?.response?.data?.message, 'error');
      return null;
    }
  }

  useEffect(() => {
    if (props.userData) {
      setFormValues({
        userId: props.userData.userId || '',
        firstName: props.userData.firstName || '',
        lastName: props.userData.lastName || '',
        userName: props.userData.userName || '',
        userPassword: props.userData.userPassword || '',
        email: props.userData.email || '',
        phone: props.userData.phone || '',
        landlineNumber: props.userData.landlineNumber || '',
        aadharNumber: props.userData.aadharNumber || '',
        address: props.userData.address || '',
        address2: props.userData.address2 || '',
        areaId: props.userData.areaId || '',
        billingAddress1: props.userData.billingAddress1 || '',
        billingAddress2: props.userData.billingAddress2 || '',
        billingAreaId: props.userData.billingAreaId || '',
        status: props.userData.status || '',
        registeredDate: props.userData.registeredDate || '',
        fingerprintStatus: props.userData.fingerprintStatus || '',
        assignedTo: props.userData.assignedTo || '',

        //extra fields
        // business: props.userData.business || '',
        // customerNumber: props.userData.customerNumber || '',
        // dateOfBirth: props.userData.dateOfBirth || '',
        // gender: props.userData.gender || '',
        // agent: props.userData.agent || '',
        // roads: props.userData.roads || '',
        // buildings: props.userData.buildings || '',
        // wing: props.userData.wing || '',
        // floor: props.userData.floor || '',
        // flatNo: props.userData.flatNo || '',
        // memberType: props.userData.memberType || '',
        // group: props.userData.group || '',
        // postcode: props.userData.postcode || '',
        // remarks: props.userData.remarks || '',
        // gstNo: props.userData.gstNo || '',
        // panNo: props.userData.panNo || '',
        // latitude: props.userData.latitude || '',
        // longitude: props.userData.longitude || '',
        isRental: props.userData.isRental || false,
        autoRenewal: props.userData.autoRenewal || false,

        prepaidCustomer: props.userData.prepaidCustomer || false,
        billingTaxType: props.userData.billingTaxType || '',
        billDate: props.userData.billDate || '',
        dueDate: props.userData.dueDate || '',
        servicePerson: props.userData.servicePerson || '',
        collectionPerson: props.userData.collectionPerson || '',
        registeredDate: props.userData.registeredDate || '',
        connectionDate: props.userData.connectionDate || '',
        fixBillAmount: props.userData.fixBillAmount || '',
        billingType: props.userData.billingType || '',
        openingAmount: props.userData.openingAmount || '',
        openingType: props.userData.openingType || '',
        isFree: props.userData.isFree || false,
        isStb: props.userData.isStb || false,
        isApk: props.userData.isApk || false,
        collectionDate: props.userData.collectionDate || '',
        oneTimeCharges: props.userData.oneTimeCharges || '',
        securityDeposit: props.userData.securityDeposit || '',
        creditLimit: props.userData.creditLimit || '',

        // NEW: package duration in months (1, 2, 3, 6, 12)
        packageDuration: props.userData.packageDuration || '',
      });
    } else {
      setFormValues(defaultFormValues);
    }
  }, [props.userData]);

  return (
    <>
      <Helmet><title>Edit Subscriber</title></Helmet>
      <Container maxWidth="lg" sx={{
        paddingBottom: '25px',
        px: { xs: 1, sm: 3 }
      }}>
        <Grid container justifyContent="center" spacing={3}>
          <Grid item xs={12}>
            <Card>
              <Divider />
              <CardContent>
                <Box sx={{ paddingBottom: "20px" }}>
                  <Box sx={{
                    paddingBottom: "20px",
                    boxShadow: 0,
                    p: { xs: 1, sm: 2 },
                    m: { xs: 0, sm: 1 },
                    borderRadius: 2,
                    textAlign: { xs: 'left', sm: 'center' }
                  }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField fullWidth required id="firstName" label="First Name" value={formValues.firstName} onChange={handleChange} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField fullWidth required id="lastName" label="Last Name" value={formValues.lastName} onChange={handleChange} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField fullWidth required id="email" label="Email" value={formValues.email} onChange={handleChange}  />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          id="userName"
                          label="Username"
                          value={formValues.userName}
                          disabled
                          autoComplete="off"
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
  fullWidth
  id="userPassword"
  label="Password"
  type={showPassword ? "text" : "password"}
  value={formValues.userPassword}
  onChange={handleChange}
  error={!!formErrors.userPassword}
  helperText={formErrors.userPassword}
  inputProps={{ minLength: 6, maxLength: 12 }}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          onClick={() => setShowPassword((prev) => !prev)}
          edge="end"
        >
          {showPassword ? (
            <VisibilityOffIcon />
          ) : (
            <VisibilityIcon />
          )}
        </IconButton>
      </InputAdornment>
    ),
  }}
/>
                      </Grid>
                      
                      <Grid item xs={12} sm={6}>
                        <TextField fullWidth required id="phone" label="Phone" value={formValues.phone} onChange={handleChange} />
                      </Grid>

                      {/* Landline Number Field - Optional */}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          id="landlineNumber"
                          label="Landline Number (Optional)"
                          value={formValues.landlineNumber}
                          onChange={handleChange}
                          autoComplete="off"
                          placeholder="Enter landline number with STD code"
                        />
                      </Grid>
                      
                      {/* Aadhaar Number Field - Optional */}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          id="aadharNumber"
                          label="Aadhaar Number (Optional)"
                          value={formValues.aadharNumber}
                          onChange={handleChange}
                          autoComplete="off"
                          placeholder="Enter 12-digit Aadhaar"
                          inputProps={{
                            maxLength: 12
                          }}
                        />
                      </Grid>
                      
                      

                      {/* <Grid item xs={12} sm={6}>
                        <FormControl fullWidth required>
                          <InputLabel id="status-label">Status</InputLabel>
                          <Select
                            labelId="status-label"
                            id="status"
                            value={formValues.status}
                            label="Status"
                            onChange={(e) =>
                              setFormValues({ ...formValues, status: e.target.value })
                            }
                          >
                            <MenuItem value="ACTIVE">ACTIVE</MenuItem>
                            <MenuItem value="INACTIVE">INACTIVE</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid> */}

                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth required>
                          <InputLabel id="fingerprintStatus">Fingerprint Status</InputLabel>
                          <Select
                            labelId="fingerprintStatus"
                            id="fingerprintStatus"
                            value={formValues.fingerprintStatus}
                            label="fingerprintStatus"
                            onChange={(e) =>
                              setFormValues({ ...formValues, fingerprintStatus: e.target.value })
                            }
                          >
                            <MenuItem value="ENABLED">ENABLED</MenuItem>
                            <MenuItem value="DISABLED">DISABLED</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      
                      <Grid item xs={12} sm={6}>
                        <TextField fullWidth id="registeredDate" label="Registered Date" value={formValues.registeredDate} onChange={handleChange} disabled />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={formValues.isRental || false}
                                onChange={(e) =>
                                  setFormValues({
                                    ...formValues,
                                    isRental: e.target.checked
                                  })
                                }
                              />
                            }
                            label="Is Rental"
                            sx={{ mt: 1 }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={formValues.autoRenewal || false}
                                onChange={(e) =>
                                  setFormValues({
                                    ...formValues,
                                    autoRenewal: e.target.checked
                                  })
                                }
                              />
                            }
                            label="Auto Renewal"
                            sx={{ mt: 1 }}
                          />
                        </Grid>

                        {/* Package Section (NEW) - visible for all companies */}
                        <Grid item xs={12}>
                          <Divider sx={{ my: 2 }}>Package</Divider>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <TextField
                            select
                            fullWidth
                            id="packageDuration"
                            name="packageDuration"
                            label="Package Duration"
                            value={formValues.packageDuration}
                            onChange={handleChange}
                            helperText="Select the validity period of the package"
                          >
                            {PACKAGE_DURATION_OPTIONS.map((months) => (
                              <MenuItem key={months} value={months}>
                                {months} {months === 1 ? 'Month' : 'Months'}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>

                        
                          <Grid item xs={12}>
                        <Divider sx={{ my: 2 }}>Installation Address</Divider>
                      </Grid>

                        <Grid item xs={12} sm={6}>
                        <TextField fullWidth id="address" label="Address" value={formValues.address} onChange={handleChange} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField fullWidth id="address2" label="Landmark/Village" value={formValues.address2} onChange={handleChange} />
                      </Grid>
                      
                      <Grid item xs={12} md={12}>
                        <Autocomplete
                          options={filteredAreaList}
                          loading={!filteredAreaList.length}
                          value={
                            filteredAreaList.find(
                              (a) => String(a.id) === String(formValues.areaId)
                            ) ?? null
                          }
                          getOptionLabel={(option) =>
                            `${option.name} / ${option.cityName} / ${option.stateName} / ${option.countryName} / ${option.zipCode}`
                          }
                          isOptionEqualToValue={(option, value) =>
                            String(option.id) === String(value.id)
                          }
                          onChange={(_, newValue) => {
                            setFormValues((prev) => ({
                              ...prev,
                              areaId: newValue ? newValue.id : ''
                            }));
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Area"
                              fullWidth
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {!filteredAreaList.length && <CircularProgress size={18} />}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                        />
                      </Grid>
                      
                      {/* Installation Address Section */}
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }}>Billing Address</Divider>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField fullWidth id="billingAddress1" label="Installation Address Line 1" value={formValues.billingAddress1} onChange={handleChange} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField fullWidth id="billingAddress2" label="Installation Address Line 2" value={formValues.billingAddress2} onChange={handleChange} />
                      </Grid>

                      <Grid item xs={12} md={12}>
                        <Autocomplete
                          options={filteredAreaList}
                          loading={!filteredAreaList.length}
                          value={
                            filteredAreaList.find(
                              (a) => String(a.id) === String(formValues.billingAreaId)
                            ) ?? null
                          }
                          getOptionLabel={(option) =>
                            `${option.name} / ${option.cityName} / ${option.stateName} / ${option.countryName} / ${option.zipCode}`
                          }
                          isOptionEqualToValue={(option, value) =>
                            String(option.id) === String(value.id)
                          }
                          onChange={(_, newValue) => {
                            setFormValues((prev) => ({
                              ...prev,
                              billingAreaId: newValue ? newValue.id : ''
                            }));
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Installation Area"
                              fullWidth
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {!filteredAreaList.length && <CircularProgress size={18} />}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                        />
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
  <Divider sx={{ my: 2 }}>Proofs</Divider>
</Grid>

<Box sx={{display:"flex",gap:'10px'}}>
  <Grid item xs={12} sm={6}>
  <Button
    variant="outlined"
    component="label"
    fullWidth
  >
    Upload ID Proof
    <input
      type="file"
      hidden
      accept=".pdf,.jpg,.jpeg,.png"
      onChange={handleFileUpload}
    />
  </Button>

  {fileError && (
    <Box sx={{ color: 'error.main', mt: 1 }}>
      {fileError}
    </Box>
  )}

  {idProofFile && (
    <Box sx={{ color: 'text.secondary', mt: 1 }}>
      Selected: {idProofFile.name}
    </Box>
  )}
</Grid>

<Grid item xs={12} sm={6}>
  <Button
    variant="outlined"
    component="label"
    fullWidth
  >
    Upload Address Proof
    <input
      type="file"
      hidden
      accept=".pdf,.jpg,.jpeg,.png"
      onChange={handleAddressProofUpload}
    />
  </Button>

  {addressProofError && (
    <Box sx={{ color: 'error.main', mt: 1 }}>
      {addressProofError}
    </Box>
  )}

  {addressProofFile && (
    <Box sx={{ color: 'text.secondary', mt: 1 }}>
      Selected: {addressProofFile.name}
    </Box>
  )}
</Grid>
</Box>
                  </Box>

                  

                  {/* acn extra fields */}
                  {companyEmail === 'acn@gmail.com' && (
  <>
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        p: 2,
        mt: 4,
        mb: 2
      }}
    >
      {/* <Typography variant="h6" gutterBottom>
        Additional Customer Information
      </Typography>

      <Divider sx={{ mb: 2 }} /> */}

      <Grid container spacing={2}>
        {/* 
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Business"
            id="business"
            value={formValues.business}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Customer Number"
            id="customerNumber"
            value={formValues.customerNumber}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            type="date"
            label="Date of Birth"
            id="dateOfBirth"
            value={formValues.dateOfBirth}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            select
            fullWidth
            label="Gender"
            id="gender"
            name="gender"
            value={formValues.gender}
            onChange={handleChange}
          >
            <MenuItem value="MALE">Male</MenuItem>
            <MenuItem value="FEMALE">Female</MenuItem>
            <MenuItem value="OTHER">Other</MenuItem>
          </TextField>
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Agent"
            id="agent"
            name="agent"
            value={formValues.agent}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Roads"
            id="roads"
            value={formValues.roads}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Buildings"
            id="buildings"
            value={formValues.buildings}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Wing"
            id="wing"
            value={formValues.wing}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Floor"
            id="floor"
            value={formValues.floor}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Flat No"
            id="flatNo"
            value={formValues.flatNo}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            select
            fullWidth
            label="Member Type"
            id="memberType"
            name="memberType"
            value={formValues.memberType}
            onChange={handleChange}
          >
            <MenuItem value="OWNER">Owner</MenuItem>
            <MenuItem value="TENANT">Tenant</MenuItem>
            <MenuItem value="FAMILY">Family</MenuItem>
          </TextField>
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Group"
            id="group"
            value={formValues.group}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Postcode"
            id="postcode"
            value={formValues.postcode}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="GST No"
            id="gstNo"
            value={formValues.gstNo}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="PAN No"
            id="panNo"
            value={formValues.panNo}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Latitude"
            id="latitude"
            value={formValues.latitude}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Longitude"
            id="longitude"
            value={formValues.longitude}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <FormControlLabel
            control={
              <Switch
                checked={formValues.isRental}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    isRental: e.target.checked
                  })
                }
              />
            }
            label="Is Rental"
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Remarks"
            id="remarks"
            value={formValues.remarks}
            onChange={handleChange}
          />
        </Grid>
            */}
        <Box
  sx={{
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    p: 2,
    mt: 2,
    mb: 2
  }}
>
  <Typography variant="h6" gutterBottom>
    Billing Configuration
  </Typography>

  <Divider sx={{ mb: 2 }} />

  <Grid container spacing={2}>
    {/* Row 1 */}

    <Grid item xs={12} sm={2}>
      <FormControlLabel
        control={
          <Switch
            checked={formValues.prepaidCustomer || false}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                prepaidCustomer: e.target.checked
              })
            }
          />
        }
        label="Prepaid Customer"
      />
    </Grid>
     <Grid item xs={12} sm={2}>
      <TextField
  select
  fullWidth
  size="small"
  label="Billing Tax Type"
  id="billingTaxType"
  name="billingTaxType"
  value={formValues.billingTaxType || ''}
  onChange={handleChange}
>
  {billingTaxTypes.map((item) => (
    <MenuItem
      key={item.id}
      value={item.id}
    >
      {item.name}
    </MenuItem>
  ))}
</TextField>
     </Grid>
    

    <Grid item xs={12} sm={2}>
      <TextField
        select
        fullWidth
        size="small"
        label="Bill Date"
        id="billDate"
        name="billDate"
        value={formValues.billDate || ''}
        onChange={handleChange}
      >
        {[...Array(31)].map((_, i) => (
          <MenuItem key={i + 1} value={i + 1}>
            {i + 1}
          </MenuItem>
        ))}
      </TextField>
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        select
        fullWidth
        size="small"
        label="Due Date"
        id="dueDate"
        name="dueDate"
        value={formValues.dueDate || ''}
        onChange={handleChange}
      >
        {[...Array(31)].map((_, i) => (
          <MenuItem key={i + 1} value={i + 1}>
            {i + 1}
          </MenuItem>
        ))}
      </TextField>
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        fullWidth
        size="small"
        label="Service Man"
        id="servicePerson"
        name="servicePerson"
        value={formValues.servicePerson || ''}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        fullWidth
        size="small"
        label="Collection Person"
        id="collectionPerson"
        name="collectionPerson"
        value={formValues.collectionPerson || ''}
        onChange={handleChange}
      />
    </Grid>

    {/* Row 2 */}

    <Grid item xs={12} sm={2}>
      <TextField
        fullWidth
        type="date"
        size="small"
        label="Registration Date"
        id="registeredDate"
        name="registeredDate"
        value={
          formValues.registeredDate
            ? formValues.registeredDate.split("T")[0]
            : ""
        }
        onChange={(e) => {
          const date = e.target.value;

          setFormValues((prev) => ({
            ...prev,
            registeredDate: date ? `${date}T00:00:00` : null,
          }));
        }}
        InputLabelProps={{ shrink: true }}
      />
    </Grid>
    
    <Grid item xs={12} sm={2}>
      <TextField
        fullWidth
        type="date"
        size="small"
        label="Connection Date"
        id="connectionDate"
        name="connectionDate"
        value={
          formValues.connectionDate
            ? formValues.connectionDate.split("T")[0]
            : ""
        }
        onChange={(e) => {
          const date = e.target.value;

          setFormValues((prev) => ({
            ...prev,
            connectionDate: date ? `${date}T00:00:00` : null,
          }));
        }}
        InputLabelProps={{ shrink: true }}
      />
    </Grid>

    {/* <Grid item xs={12} sm={2}>
      <TextField
        fullWidth
        type="date"
        size="small"
        label="Connection Date"
        id="connectionDate"
        value={formValues.connectionDate || ''}
        onChange={handleChange}
        InputLabelProps={{ shrink: true }}
      />
    </Grid> */}

    <Grid item xs={12} sm={2}>
      <TextField
        fullWidth
        size="small"
        label="Fix Bill Amount"
        id="fixBillAmount"
        value={formValues.fixBillAmount || ''}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        select
        fullWidth
        size="small"
        label="Billing Type"
        id="billingType"
        name="billingType"
        value={formValues.billingType || ''}
        onChange={handleChange}
      >
        <MenuItem value="MONTHLY">Monthly</MenuItem>
        <MenuItem value="QUARTERLY">Quarterly</MenuItem>
      </TextField>
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        fullWidth
        size="small"
        label="Opening Amount"
        id="openingAmount"
        value={formValues.openingAmount || ''}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        select
        fullWidth
        size="small"
        label="Opening Type"
        id="openingType"
        name="openingType"
        value={formValues.openingType || ''}
        onChange={handleChange}
      >
        <MenuItem value="DEBIT">Debit</MenuItem>
        <MenuItem value="CREDIT">Credit</MenuItem>
      </TextField>
    </Grid>

    {/* Row 3 */}

    <Grid item xs={12} sm={2}>
      <FormControlLabel
        control={
          <Switch
            checked={formValues.isFree || false}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                isFree: e.target.checked
              })
            }
          />
        }
        label="Free"
      />
    </Grid>

    <Grid item xs={12} sm={2}>
      <FormControlLabel
        control={
          <Switch
            checked={formValues.isStb || false}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                isStb: e.target.checked
              })
            }
          />
        }
        label="Device"
      />
    </Grid>
    <Grid item xs={12} sm={2}>
      <FormControlLabel
        control={
          <Switch
            checked={formValues.isApk || false}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                isApk: e.target.checked
              })
            }
          />
        }
        label="APK"
      />
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        select
        fullWidth
        size="small"
        label="Collection Date"
        id="collectionDate"
        name="collectionDate"
        value={formValues.collectionDate || ''}
        onChange={handleChange}
      >
        {[...Array(31)].map((_, i) => (
          <MenuItem key={i + 1} value={i + 1}>
            {i + 1}
          </MenuItem>
        ))}
      </TextField>
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        fullWidth
        size="small"
        label="One Time Charges"
        id="oneTimeCharges"
        value={formValues.oneTimeCharges || ''}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        fullWidth
        size="small"
        label="Security Deposit"
        id="securityDeposit"
        value={formValues.securityDeposit || ''}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        fullWidth
        size="small"
        label="Credit Limit"
        id="creditLimit"
        value={formValues.creditLimit || ''}
        onChange={handleChange}
      />
    </Grid>
  </Grid>
</Box>
      </Grid>
    </Box>

    {/* Billing Configuration Box goes here */}
  </>
)}
                  <Box sx={{
                    display: 'flex',
                    justifyContent: { xs: 'center', sm: 'flex-end' },
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: 1,
                    mt: 2
                  }}>
                    <Button sx={{ marginInline: "8px" }} onClick={handleClose} variant="contained" disabled={loading}>Cancel</Button>
                    <Button onClick={onUpdate} variant="contained" disabled={loading}>
                      {loading ? <CircularProgress size={24} /> : 'Update'}
                    </Button>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>

      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <MuiAlert elevation={6} variant="filled" severity={snackbarSeverity} onClose={handleSnackbarClose}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default EditUser;